export function isItemLevel1(el) {
    if (el) {
      for (var i = 0; i < el.classList.length; i++) {
        if (el.classList[i] == "menuLevel1") {
          return true;
        }
      }
    }
    return false;
  }